import * as React from 'react';

interface WTableFilterVorhandenSelectProps extends React.ClassAttributes<any> {
    onChange: (stamp: any) => void;
    item?: any;
}

interface WTableFilterVorhandenSelectState {
    selected: string;
}

export class WTableFilterVorhandenSelect extends React.Component<WTableFilterVorhandenSelectProps, WTableFilterVorhandenSelectState> {
    constructor(props: any) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {
            selected: '0'
        };
    }

    onChange(selected: string) {
        this.setState({
            selected,
        }, () => {
            let showVorhanden = true;
            let showNotVorhanden = true;
            if (selected === '1') {
                showNotVorhanden = false;
            } else if (selected === '2') {
                showVorhanden = false;
            }
            this.props.onChange({ showVorhanden, showNotVorhanden });
        });
    }

    render() {
        const chbox = this.props.item && this.props.item.type === 'CHECKBOX';
        return (
            <select
                style={{ width: '100%', height: '18px' }}
                value={this.state.selected}
                onChange={(evt: any) => this.onChange(evt.target.value)}
            >
                <option value={0}>alle</option>
                <option value={1}>{chbox ? 'ja' : 'vorhanden'}</option>
                <option value={2}>{chbox ? 'nein' : 'nicht vorhanden'}</option>
            </select>
        );
    }
}
